import React, { PureComponent } from 'react';
import { PrimaryButton } from 'appSrc/components/UI';
import { connect } from 'react-redux';
import { Field, reduxForm, Form, change } from 'redux-form';
import ImageCropModalWrapper from 'appSrc/components/ImageUpload/CropModalWrapper';
import { FormTextField,FormToggle } from 'appSrc/components/UI/ReduxForm';
import Edit from 'appSrc/components/Icons/Edit';
import style from './styles/style.module.css';

class EditInterestForm extends PureComponent {
    constructor( props ) {
        super( props );

        this.state = {
            selectedImage: this.props.initialValues.coverImage,
        };
    }
    cropFinish = ( imageData ) => {
        this.setState( {
            selectedImage: imageData,
        } );
        if( imageData != null ) {
            this.props.changeFieldValue( 'coverImage', imageData );
        }
    }
    render() {
        const { handleSubmit } = this.props;
        const { selectedImage } = this.state;
        return (
            <Form
            className={ style.categoryForm }
            onSubmit={ handleSubmit( this.props.onSubmit ) }>
                <div className={ style.topLevel }>
                    <div className={ style.imageWrapper }>
                        <ImageCropModalWrapper
                        onFinish={ this.cropFinish }>
                            { !!selectedImage ?
                                <img src={ selectedImage } />
                                :
                                <Edit />
                            }
                        </ImageCropModalWrapper>
                    </div>
                    <div className={ style.detailsWrapper }>
                        <Field
                        id="interest"
                        name="interest"
                        label="Title"
                        component={ FormTextField }
                        fullWidth
                        />
                        <Field
                        id="description"
                        name="description"
                        label="Description"
                        component={ FormTextField }
                        fullWidth
                        multiLine
                        />
                        <Field
                        id="slug"
                        name="slug"
                        label="Slug"
                        component={ FormTextField }
                        fullWidth
                        />
                        <Field
                        id="deactivated"
                        name="deactivated"
                        label="Deactivated"
                        component={ FormToggle }
                        style={ { marginTop: '10px' } }
                        />

                        <PrimaryButton
                        label="Submit"
                        fullWidth
                        type="submit"
                        style={ { marginTop: '45px' } }/>
                    </div>
                </div>
            </Form>
        );
    }
}

EditInterestForm = reduxForm( {
    form: 'EditInterestForm',
} )( EditInterestForm );


const mapDispatchToProps = ( dispatch ) => {
    return {
        changeFieldValue: ( field, value ) => {
            dispatch( change( 'EditInterestForm', field, value ) );
        },
    };
};

export default connect( null, mapDispatchToProps )( EditInterestForm );
